<template>
  <CustomModal :title="!ordemServicoItem.ordem_servico_item_id ? 'Criar Item Ordem de Serviço' : 'Visualizar Item Ordem de Serviço'"
               :show="propShow"
               size="xl"
               :disabled-button="!ordemServicoItem.custa.custa_id || !!ordemServicoItem.ordem_servico_item_id"
               :title-button="!!ordemServicoItem.ordem_servico_item_id? 'Editar' : 'Adicionar item'"
               @closeModal="handlerCloseModal"
               @ok="handlerEmitData">
    <div>
      <div class="row pl-4 pt-2 pb-3">
        <!-- Tipo Custa -->
        <div class="col-4 d-flex justify-content-between">
          <b-form-radio
            v-model="tipoCustas"
            class="h5"
            :disabled="computedItemId"
            value="REGISTRO_CIVIL"
            @change="resetForm($event)">
            Registro Civil
          </b-form-radio>
          <b-form-radio
            v-model="tipoCustas"
            :disabled="computedItemId"
            class="h5"
            value="ATOS_NOTARIAIS"
            @change="resetForm($event)">
            Atos Notariais
          </b-form-radio>
        </div>
      </div>
      <!-- Campos Preenchimento -->
      <div class="row m-2">
        <div class="col-4 pl-3">
          <div class="form-group">
            <CustomSelect name="custa_select"
                          :options="computedCustas"
                          :label="computedItemId? 'Custa selecionada' : 'Selecione a custa'"
                          :selected="ordemServicoItem.custa.ato"
                          :disabled="computedItemId"
                          :max-height-display="200"
                          @setSelectValue="(ev) => selectCusta(ev)" />
          </div>
        </div>

        <div class=" col-4 pl-3">
          <CustomInput
            name="descricao"
            label="Descrição"
            :initial-value="ordemServicoItem && ordemServicoItem.descricao"
            :disabled="computedItemId"
            type="text"
            @blur="setValueInput" />
        </div>

        <div class="col-1 pl-2">
          <CustomInput
            name="quantidade"
            label="Qtde"
            :initial-value="ordemServicoItem && ordemServicoItem.quantidade"
            :disabled="disableQtd() || computedItemId"
            type="number"
            @blur="setValueInput" />
        </div>

        <div class="col-1 pl-2">
          <CustomInput
            name="averbacao"
            label="Averbação"
            :disabled="computedItemId"
            :initial-value="ordemServicoItem.averbacao"
            type="number"
            @blur="setValueInput" />
        </div>

        <div class="col-2 pl-3">
          <CustomInput
            name="valor"
            label="Valor"
            :initial-value="(ordemServicoItem.valor || 0) | moneyToString"
            :disabled="true"
            type="text" />
        </div>
      </div>
      <!-- Opções de seleção -->
      <div class="row pl-4 pt-4 pr-4">
        <div class="col-3">
          <b-form-checkbox
            :id="`utilizar_tabela_cartorio_${ _uid }`"
            v-model="tabelaCartorio"
            :disabled="computedItemId"
            :value="true"
            @change="resetForm()">
            Utilizar tabela do cartório
          </b-form-checkbox>
        </div>
        <div class="col-2">
          <b-form-checkbox
            :id="`zerar_custas_${ _uid }`"
            v-model="ordemServicoItem.zerarCusta"
            :disabled="computedItemId || !ordemServicoItem.custa.custa_id"
            @change="zerarTotal"
            @keyup.native.enter="zerarTotal">
            Zerar custas
          </b-form-checkbox>
        </div>
        <div id="check-box-gerar-selo"
             class="col-2">
          <b-form-checkbox :id="`gerar_selo_${ _uid }`"
                           v-model="ordemServicoItem.seloStatus"
                           :disabled="
                             computedItemId || 
                               !ordemServicoItem.custa.custa_id ||
                               !ordemServicoItem.custa.tipo_ato"
                           @change="verifySelo">
            Gerar selo
          </b-form-checkbox>
          <b-tooltip v-if="ordemServicoItem.custa.custa_id && !ordemServicoItem.custa.tipo_ato"
                     target="check-box-gerar-selo"
                     triggers="hover">
            A custa selecionada não gera selo
          </b-tooltip>
        </div>

        <div id="check-box-impresso"
             class="col-3">
          <b-form-checkbox
            v-model="ordemServicoItem.impressosSeguranca"
            :disabled="
              computedItemId ||            
                !ordemServicoItem.custa.custa_id ||
                (ordemServicoItem.custa.requiredImpresso && ordemServicoItem.seloStatus) ||
                !ordemServicoItem.custa.impresso_seguranca">
            Impressos de segurança
          </b-form-checkbox>
          <b-tooltip v-if="ordemServicoItem.custa.custa_id && !ordemServicoItem.custa.impresso_seguranca"
                     target="check-box-impresso"
                     triggers="hover">
            A custa selecionada não consome impresso de segurança
          </b-tooltip>
        </div>
        <!-- Selos Duplos -->
        <div v-if="ordemServicoItem.custa && ordemServicoItem.custa.selo_duplo"
             class="col-12 d-flex mt-3">
          <div class="d-flex pt-2">
            <label class="pr-2"
                   :for="`assento_item_cadastro_${ _uid }`">
              {{ `- Gerar selo duplo - ${getTipoSeloDuplo(ordemServicoItem.custa.selo_duplo)}` }}
            </label>
            <b-form-checkbox
              :id="`assento_item_cadastro_${ _uid }_cadastro`"
              v-model="ordemServicoItem.seloDuplo"
              :disabled="!!ordemServicoItem.ordem_servico_item_id" />
          </div>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<script>
  // contants
  import custas from '@/constants/custas'
  // Services
  import CustasService from '@/services/Registros/CustasService'
  // outros
  import { mapGetters } from 'vuex'
  // Componentes
  import CustomInput from "@/components/CustomInputs/CustomInput"
  import CustomSelect from "@/components/CustomInputs/CustomSelect"
  import CustomModal from "@/components/CustomModal/CustomModal"
  // Entities
  import OrdemServicoItem from '@/entities/OrdemServicoItem/OrdemServicoItem.js'
  import Custa from '@/entities/Custas/Custa.js'
  // Store
  import store from '@/store/index'

  export default {
    name: "OrdensServicoFormItem",
    components: {
      CustomInput,
      CustomSelect,
      CustomModal,
    },
    props: {
      propTipo: String,
      propCustas: {type: Array, default: () => []},
      propShow: {
        type: Boolean,
        default: false
      },
      propNovo: {
        type: Boolean,
        default: false
      },
      propItem: {
        type: [Object, Boolean],
        default: () => ({})
      },
      propGerarCpf: {
        type: Boolean,
        default: false
      },
      propPedidoCrc: {
        type: Boolean,
        default: false
      },
      propNovoProcedimento: {
        type: Boolean,
        default: false
      },
      propOrdemServico: {
        type: Object,
        default: () => {}
      },
      propRegistro: { 
        type: Object, 
        default: () => { return {} }
      }
    },
    data () {
      return {
        ordemServicoItem: new OrdemServicoItem(),
        custasAtivas: [],
        tabelaCartorio: false,
        ordemServico: {},
        custas: custas,
        tipoCustas: 'REGISTRO_CIVIL',
        custasComImpressos: false,
      }
    },
    computed: {
      computedCustas () {

        let custaList = this.custasAtivas.filter((custa) => {
   
          if (!this.tabelaCartorio && custa.registro_oficial) {
            // Registro
            if (this.propTipo) {
              if (this.propTipo === custa.tipo_registro || custa.tipo_registro === 'todos') return custa
            }
            // Avulsas
            if (custa.tipo_registro === 'todos') return custa
          } else if (this.tabelaCartorio && !custa.registro_oficial) {
            if (custa && custa.cartorio_id == this.cartorioObj.cartorio_id) return custa
          }   

        }).filter((custa) => {
          if (this.tipoCustas === 'REGISTRO_CIVIL') {
            return custa.tipo === this.tipoCustas
          } else {
            return custa.tipo !== 'REGISTRO_CIVIL'
          }
        })
        custaList = custaList.map((custa) => { return {value: custa, text: custa.ato}})

        return custaList
      },

      computedItemId () {
        return !!this.ordemServicoItem.ordem_servico_item_id
      },

      ...mapGetters({
        zerarCustas: 'procedimento/getZerarCustas',
        inteiroTeor: 'procedimento/getInteiroTeor',
        alteracaoEstadoCivil: 'procedimento/getAlteracaoEstadoCivil',
        cartorioObj: 'auth/getCartorioObj'
      })
    },
    watch: {
      propCustas () {
        if (this.propCustas.length) this.custasAtivas = this.propCustas  
      },
      'propItem.ordem_servico_item_id' () {
        this.init()
      },
    },
    async created () {
      await this.init()
    },
    mounted () {
      if (this.zerarCustas) {
        this.ordemServico.zerarCusta = this.zerarCustas
      }
    },
    methods: {
      async init () {
        if (this.propItem.custa?.custa_id) {
          this.ordemServicoItem = new OrdemServicoItem(this.propItem)
          this.tipoCustas = this.ordemServicoItem.custa.tipo
          this.tabelaCartorio = !this.ordemServicoItem.custa.registro_oficial ? true : false
          return
        }
        this.ordemServicoItem = new OrdemServicoItem()
      },
      handlerEmitData () {
        this.$emit('ok', this.ordemServicoItem)
        this.ordemServicoItem = new OrdemServicoItem()
      },  
  
      setValueInput (nome, value) {     
        this.ordemServicoItem[nome] = value
      },
      selectCusta (custa) {
        if (!custa) {
          this.resetForm()
          return
        } 

        let tipoRegistro = this.propTipo

        // Verificamos o tipo do registro para tratar caso seja um Natimorto
        tipoRegistro = !!this.propRegistro && this.propRegistro.tipo_registro == 'NT' ? 'natimorto' : this.propTipo

        this.ordemServicoItem.setCusta(custa.value, tipoRegistro)  
      },
      zerarTotal () {
        this.ordemServicoItem.zerarCusta = this.ordemServicoItem.zerarCusta ? false : true
        if (this.ordemServicoItem.zerarCusta) {
          this.ordemServicoItem.valor = 0
          return
        } else {
          this.ordemServicoItem.valor
        }
      },
      getTipoSeloDuplo (sigla) {
        switch (sigla) {
        case 'TR':
          return 'Traslado'
          break
        case 'PV':
          return 'Assento'
          break        
        default:
          break
        }
      },
      disableQtd () {
        const custa = this.custasAtivas.find(custa => this.ordemServico.custa_id === custa.custa_id)
        const codigos = [9, 16, 17]
        if (!this.ordemServicoItem.custa.custa_id || (custa && codigos.includes(custa.codigo))) return true
      },
      handlerCloseModal () {
        this.ordemServicoItem = new OrdemServicoItem()
        this.$emit('closeModal')
      },
      resetForm () {
        // Status
        this.permiteSelo = false
        this.consomePapel = false
        this.tabelaCartorio = false
        // Item OS
        this.ordemServicoItem.seloStatus = false
        this.ordemServicoItem.impressosSeguranca = false
        this.ordemServicoItem.seloTraslado = false,
        this.ordemServicoItem.seloCertidao = false
        this.ordemServicoItem.zerarCusta = false
        this.ordemServicoItem.descricao = null
        this.ordemServicoItem.quantidade = 1
        this.ordemServicoItem.averbacao = 0
        this.ordemServicoItem.valor = 0
        this.ordemServicoItem.custa = {}

      },
      verifySelo ()  { 
        // Caso seja uma custa de selo fisico e esteja com a opção para gerar selo devemos deixar obrigatório o consumo de impresso
        // Obs: os selos fisicos utilizam a numeração do impresso para compor a numeração do selo digital
        if (!!this.ordemServicoItem && !!this.ordemServicoItem.custa && !!this.ordemServicoItem.custa.requiredImpresso && !this.ordemServicoItem.seloStatus) {
          this.ordemServicoItem.impressosSeguranca = true
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .OrdensServicoFormServicos {
    &_isInvalid {
      border: 1px solid red !important;
      border-radius: 5px !important;
      border-color: #ed0909 !important;
    }
  }

  .columnDescricao {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 35%;
    flex: 0 0 35%;
    max-width: 35%;
  }

  .columnValores {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 10%;
    flex: 0 0 10%;
    max-width: 10%;
  }
</style>
